<template>
  <div class="container">
    <div class="row bottom-margin top-margin">
      <div class="col text-center">
        <h2>Frequently Asked Questions</h2>
      </div>
    </div>
    <div class="row bottom-margin">
      <div class="col-md-6 text-center">
        <div class="card" v-on:click="currentCenter = 'HomFAXQuestions'">
          <img src="/static/YarlowLogo.svg" class="logo">
          <!--<div class="row card-row">
            <div class="col my-auto card-col">
              <h2 class="card-title">Yarlow HomFAX</h2>
            </div>
          </div>-->
        </div>
      </div>
      <div class="col-md-6 text-center">
        <div class="card navy-background" v-on:click="currentCenter = 'RealEstate'">
          <img src="/static/HomAptRealtyLogo.svg" class="logo">
          <!--<div class="row card-row">
            <div class="col my-auto card-col">
              <h2 class="card-title">Real Estate</h2>
            </div>
          </div>-->
        </div>
      </div>
    </div>
    <homfax-questions v-if="currentCenter === 'HomFAXQuestions'" class="bottom-margin"></homfax-questions>
    <real-estate v-if="currentCenter === 'RealEstate'" class="bottom-margin"></real-estate>
  </div>
</template>

<script>
import HomfaxQuestions from './categories/HomFAXQuestions.vue'
import RealEstate from './categories/RealEstate.vue'

// https://bootstrap-vue.js.org/docs/components/collapse
export default {
  data () {
    return {
      currentCenter: 'HomFAXQuestions'
    }
  },
  components: {
    HomfaxQuestions,
    RealEstate
  }
}
</script>

<style scoped>
.bottom-margin {
  margin-bottom: 6rem;
}

.card {
  height: 250px;
  border-radius: 30px;
  padding-bottom: 2rem;
}

.card:hover {
  cursor: pointer;
}

.card-row {
  height: 100%;
}

.card-title {
  color: rgb(254, 237, 170) !important;
}

.logo {
  max-height: 100%;
  margin: 1rem;
}

.navy-background {
  background-color: #343a40 !important;
}

.no-margin {
  margin-bottom: 0px;
}

.subnav-item {
  margin-right: 1rem;
  margin-left: 1rem;
}

.subnav-item:hover {
  cursor: pointer;
}

.top-margin {
  margin-top: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/faq/FAQ.vue